import Flex from "@ui-kit/layout/Flex/Flex.web";
import { ASSIGNED_SEATING } from "@shared/constants";
import Button from "@ui-kit/form/Button/Button.web";
import Modal from "@ui-kit/overlays/Modal/Modal.web";
import { useTranslation } from "@shared/utils/internationalization";
import { ItemSelectModalProps, MapItemType } from "./ItemSelectModal.props";
import SelectionItem from "./SelectionItem/SelectionItem.web";
import { useItemSelectModal } from "./useItemSelectModal";

/**
 * Selection modal which opens from clicking on multi-ticket seats or GA locations.
 */
const ItemSelectModal = (props: ItemSelectModalProps) => {
  const { t } = useTranslation("seating");

  const { itemsOnSeat, isOpen, onClose, resolve } = props;
  const { $name } = itemsOnSeat;

  const {
    locationSelections,
    itemSelectData,
    getCurrentSelectedAmount,
    selectItemPermission,
  } = useItemSelectModal(props);

  const cancelModal = () => {
    onClose(null);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={cancelModal}
      isCentered
      scrollBehavior="inside"
      size="3xl"
    >
      <Modal.Header>{itemSelectData?.title ?? ""}</Modal.Header>
      <Modal.Body>
        <Flex
          data-testid="item-selection-modal"
          w="full"
          direction="column"
          gap="md"
          mt="none"
        >
          {itemSelectData?.itemTypes.map((item: MapItemType) => {
            return (
              <SelectionItem
                key={item.id}
                item={item}
                itemSelectData={itemSelectData}
                getCurrentSelectedAmount={getCurrentSelectedAmount}
                selectItemPermission={selectItemPermission}
                {...props}
              />
            );
          })}
        </Flex>
      </Modal.Body>
      {$name === ASSIGNED_SEATING.GENERAL_ADMISSION.ID ? (
        <Modal.Footer>
          <Flex justifyContent="flex-end">
            <Button
              data-testid="item-select-modal-select-ga-locations"
              minWidth="140px"
              variant="solid"
              colorPalette="primary"
              onClick={() => resolve(locationSelections)}
            >
              {t("Continue", { ns: "common" })}
            </Button>
          </Flex>
        </Modal.Footer>
      ) : (
        <></>
      )}
    </Modal>
  );
};

export default ItemSelectModal;
